import { AgencyInfoAccountType } from '@urbanx/agx.agencies.client';

export const shouldHideReportingDashboard = (
  accountType: AgencyInfoAccountType | null | undefined
) => {
  // Autopilot accounts do not have reporting access.
  // UrbanX agencies keep reporting access, including states without campaign forms.
  return accountType === AgencyInfoAccountType.Autopilot;
};
